import { RelevantLabDocument } from "./relevant-lab-document.model";

export class RelevantLab {
    id?: string;
    test_name: string;
    test_description?: string;
    test_date: string;
    documents?: RelevantLabDocument[] = [];
    document_name?: string;
    document_attached?: string;
    document_type?: string;
    patient_id?: string;
    appointment_id?: string;
}